'use client';

import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';

import { GlobalContextProvider } from '@context/global';

export default function GlobalPageWrapper({ children }) {

    const matomoInstance = createInstance({
        urlBase: process.env.NEXT_PUBLIC_MATOMO_URL_BASE,
        siteId: process.env.NEXT_PUBLIC_MATOMO_SITE_ID
    });

    return (
        <MatomoProvider value={matomoInstance}>
            <GlobalContextProvider>
                <div className="app-container">
                    {children}
                </div>
            </GlobalContextProvider>
        </MatomoProvider>
    );
}